module.exports = __webpack_public_path__ + "static/media/attachment.23ab5d0f.png";